import { Form, Input, message } from "antd";
import { Button, Card } from "react-bootstrap"
import { useDispatch, useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { setPreviewDetail, validateClassCode } from "../../store/editclass/actions";
import { useEffect, useState } from "react";


const PreviewCodePopup = () => {
    const dispatch = useDispatch();
    const store = useStore();
    const history = useHistory();
    const [classId, setClassId] = useState<number | null>()
    const [form] = Form.useForm()
    let { class_id } = useParams<{ class_id: string }>();

    useEffect(() => {

        const unsubscribe = store.subscribe(() => {
            let res = store.getState().SearchReducer;
            if (res.data && res.data.code === 404) {
                message.error("Code ไม่ถูกต้อง")
                return
            }
            if (res.table === "validate_class_code") {
                setClassId(res.data)
            }
        })

        return unsubscribe;
    }, [])

    useEffect(() => {
        if (classId) {
            dispatch(setPreviewDetail({class_id: classId, class_code: form.getFieldValue("code")}))
            history.push('/preview/assignment/' + class_id);
        }
    }, [classId])

    const onSubmit = () => {
        dispatch(validateClassCode(parseInt(class_id), form.getFieldValue("code")));
    };

    return <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Card style={{ width: 400, height: 150, margin: 24, padding: 24 }}>
            <Form form={form} onFinish={onSubmit}>

                <div style={{ display: "flex" }}>
                    <span style={{ marginRight: 8 }}>Code: </span>
                    <Form.Item name="code" rules={[{ required: true, message: "กรุณากรอก Code" }]}>
                        <Input style={{ width: 300 }} />
                    </Form.Item>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button style={{ padding: 8, marginTop: 24, height: 36, fontSize: 16 }} variant="primary" size="sm" type="submit">
                        Submit
                    </Button>
                </div>
            </Form>

        </Card>
    </div>
}

export default PreviewCodePopup;